var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { S3_RESOURCE_SELECTOR_ITEM_TYPES } from './s3-config';
var SCHEME = 's3://';
var pipe = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduce(function (prevFn, nextFn) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return nextFn(prevFn.apply(void 0, args));
    }; }, function (value) { return value; });
};
export var uriToEntities = function (uri) {
    var path = uri.replace(SCHEME, '');
    return path.length === 0 ? [] : path.split('/');
};
export var entitiesToUri = function (entities) {
    return entities.length === 0 ? '' : SCHEME + entities.join('/');
};
export var resourceToUri = function (resource) {
    return resource ? resource.uri || '' : '';
};
export var entitiesToResource = function (entities) {
    return {
        uri: entitiesToUri(entities)
    };
};
export var entityToBreadcrumb = function (entity, index) {
    return {
        text: entity,
        href: index.toString()
    };
};
export var extractBreadcrumbs = function (rootItem, resource) {
    return pipe(resourceToUri, uriToEntities, function (entities) { return __spreadArrays([rootItem], entities).map(entityToBreadcrumb); })(resource);
};
export var uriToResource = function (uri) {
    return {
        uri: uri
    };
};
export var drilldown = function (resource, item) {
    return pipe(resourceToUri, uriToEntities, function (entities) { return __spreadArrays(entities, [item]); }, entitiesToResource)(resource);
};
export var navigate = function (resource, index) {
    return pipe(resourceToUri, uriToEntities, function (entities) { return entities.slice(0, index); }, entitiesToResource)(resource);
};
export var getItemsType = function (resource) {
    var bucketName = resource.uri.substring(5).split('/')[0];
    return !bucketName ? S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS : S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS;
};
export var isDrilldownAllowed = function (selectableItemsTypes, itemsType) {
    var selectableItemsTypesLowered = selectableItemsTypes.map(function (itemsType) { return itemsType.toLowerCase(); });
    var versionsSelectable = selectableItemsTypesLowered.indexOf(S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS) > -1;
    var objectsAreSelectable = selectableItemsTypesLowered.indexOf(S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS) > -1;
    var currentStepObjects = itemsType === S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS;
    var currentStepVersions = itemsType === S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS;
    return !currentStepVersions && (versionsSelectable || (objectsAreSelectable && currentStepObjects));
};
export var isItemsTypeSelectable = function (selectableItemsTypes, itemsType) {
    return selectableItemsTypes.map(function (type) { return type.toLowerCase(); }).indexOf(itemsType) > -1;
};
//# sourceMappingURL=uri.js.map